/**
 * Birthplaces as rest-api keeps them (the stores' `_location`):
 * `{ fullAddress, coordinates: { lat, lng } }`. The wheel chart and the
 * generated text need the coordinates; a bare name has none.
 */

/** The place from whatever a book or a field holds: a string, the stored shape, or null. */
export function toPlace(value) {
  if (!value) return null
  if (typeof value === 'string') return { fullAddress: value }
  const fullAddress = value.fullAddress || value.name || value.address || ''
  const c = value.coordinates
  const coordinates =
    c && typeof c.lat === 'number' && typeof c.lng === 'number' ? { lat: c.lat, lng: c.lng } : null
  return coordinates ? { fullAddress, coordinates } : { fullAddress }
}

export function hasCoordinates(value) {
  const place = toPlace(value)
  return !!(place && place.coordinates)
}

/** What the API takes: the place with its coordinates, or the bare name as before. */
export function placePayload(value) {
  const place = toPlace(value)
  if (!place || !place.fullAddress.trim()) return null
  const fullAddress = place.fullAddress.trim()
  return place.coordinates ? { fullAddress, coordinates: place.coordinates } : fullAddress
}
